// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateTask_wrapper__X6WJP","dark":"CreateTask_dark__M5MWm"};